import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ISportCircleIconProps extends ISvgIconProps {

}

export class SportCircleIcon extends React.Component<ISportCircleIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path d="M12 2.4A9.6 9.6 0 1 1 2.4 12 9.611 9.611 0 0 1 12 2.4Zm0 13.803A4.203 4.203 0 1 0 7.8 12 4.208 4.208 0 0 0 12 16.2Z" fill="#fa6200"/>
                </g>
            </SvgIcon>
        );
    }
}
